//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FootButton from "../components/FooterBtn.vue";
import Catalog from "../components/catalog.vue";
import CcDialog from "../components/dialog.vue";

export default {
  name: "audioDetail",
  components: {
    FootButton,
    Catalog,
    CcDialog
  },
  data() {
    return {
      isOrangeNews: false,
      show: false,
      isLogin: true,
      audioState:false, //触发状态，避免重复触发导致音频自动暂停
      audioHidden: false,
      imgNone: require("@/assets/image/photo/p1.jpg"),
      pageData: "",
      mediaData: "",
      mediaId: "",
      metas: [],
      BuyDialog: false,
      paly: false,
      imgNull: require("@/assets/image/icon/icon_null.png"),
      errData:{
        code:false
      },
      detailCoverUrl: '',
      pageDataDetailCoverUrl: '',
      audioObjUrl: [],
      audionIndex: 0,
      //用于显示的播放状态
      duration: '00:00',
      currentDuration: '00:00',
      durationValue: 100,
      currentDurationValue: 0,
      progress: 0,
      audio: '',
      volume: 1,
      paused: true,
      isMoveIn: false, //是否在移动中
      showVolumePanel: false,
      volumeVisible: false,
      //audioSrc: 'http://nowbook-info.oss-cn-hongkong.aliyuncs.com/LzE2MzI0NzYxNjExNjdyZW5ldzAy56ys5LiA56ug77ya44CM6aGb6KaG44CN4oCU4oCU6aaZ5riv5q235Y-y55qE6ZW35bqm5ZKM5Y6a5bqmLm1wMw?Expires=1690788509&OSSAccessKeyId=LTAI3MlVyHfQ7xyf&Signature=OSFg6GkpVDeBQexzESdKu%2BbXkm4%3D',
      audioSrc: '',
      backSecond: '15',
      forwardSecond: '15',
      iconAll: {
        iconNone: require("@/assets/image/icon/dele.png"),
        iconPlayBlack: require("@/assets/image/icon/icon_play_black.png"),
        iconGroup: require("@/assets/image/icon/icon_h_group.png"),
        iconLock: require("@/assets/image/icon/icon_lock.png"),
        iconDownLoad: require("@/assets/image/icon/icon_download.png"),
        iconPrevious: require("@/assets/image/icon/icon_previous.png"),
        iconNext: require("@/assets/image/icon/icon_next.png"),
        iconPlayNoborder: require("@/assets/image/icon/icon_play_noborder.png"),
        iconPauseNoborder: require("@/assets/image/icon/icon_pause_noborder.png"),
        iconM15Second: require("@/assets/image/icon/m15second.png"),
        iconP15Second: require("@/assets/image/icon/p15second.png"),
        iconAudiosetting: require("@/assets/image/icon/audiosetting.png"),
        iconRelBook: require("@/assets/image/icon/icon_linkBook.png"),
        iconsetPlayRate: require("@/assets/image/icon/setPlayRate.png"),
        iconsetWords: require("@/assets/image/icon/setWords.png"),
        iconsetTest: require("@/assets/image/icon/setTest.png"),
        iconLine: require("@/assets/image/icon/line.png")
      },
      accessRegion:true,//true 为可以进行阅读，false说明ip为非可阅读区域ip
      columnId: null,
      curPlayIndex: -1,

      hasPre: false,
      hasNext: false,
      audioNum: 0

    };
  },
  created: function() {
    //console.log("aa");
  },
  methods: {
    //返回上一页
    onClickLeft(){
      //this.$router.go(-1)
      this.$router.back()
    },
    onMouseMove() {
        if (!this.audioState) {
         // 获取元素标签
          let audioDom = document.getElementById('audio')
          // 触发交互
          audioDom.pause()
          this.audioState = true
          //console.log('触发交互');
        }
    },
    openApps() {
      this.BuyDialog = !this.BuyDialog;
    },
    goBuy() {
      this.BuyDialog = false;
      var accessRegion = true;
       this.items.forEach((item) => {
         accessRegion = accessRegion && item.accessRegion;
       })
      if(!accessRegion){
        let params = {
          message:this.$t('PAGE_HEADER_TITLE.regionTitleBuy'),
          yesLabel:this.$t('REGISTER_SUCCESS_LANG.btnText')
        }
        Dialog.alert({
          message: JSON.stringify(params),
        }).then(() => {
          // on close
        });
        return
      }
      this.$emit("doBuy", {});
    },

    cancelDialog() {
      this.BuyDialog = false;
    },
    type(type) {
      this.paly = type;
      console.log(type);
    },
    getData() {
      //獲取詳情
      let mediaPost = {
        //id: this.mediaId,
        id: this.$route.query.columnId,
        isValid: true
      };
      //console.log('run this 222');
      this.$toast.loading();
      this.CCrequest.doSessionAxios(this.CONFIG.MEDIA.COLUMN, mediaPost, "GET", "no login").then(res => {
          this.$toast.close();
          console.log('res11', res);
          // res.items[2].canTry = 0;
          this.pageData = res;

          //找到當前播放的數據
          if (this.mediaId) {
            res.items.forEach((item, index) => {
              if (item.id == this.mediaId) {
                this.audionIndex = index;
                this.mediaData = item
              }
            });
          }

          //设置是否有上下首
          this.hasPre = this.audionIndex != 0;
          this.hasNext = this.audionIndex + 1 < res.items.length;


          this.show = true;
          //this.getAudioData(this.mediaId); //当前音频
          this.onPlay(this.audionIndex, this.mediaId)
          console.log('mediaData',this.mediaData, this.audionIndex);
        }).catch(err => {
          console.log('errData',this.errData);
      });

    },
    //獲取媒體詳情
    getAudioData(mediaId,index){
      let postD = {
        id: mediaId
      };
      this.$toast.loading();
      this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.FILE.GETPLAYURL, postD, "GET", "no login")
        .then(res => {
          //console.log('獲取媒體url',mediaId, res.data.url);
          this.audioSrc = res.data.url
          this.$toast.close();

          let recordAudio = this.$refs.audio; //获取audio元素
          recordAudio.src = this.audioSrc;
          //recordAudio.play();
          this.paused = false
          this.onMouseMove();
          setTimeout(function(){
            recordAudio.play();
          },200)
        })
        .catch(err => {
          this.$toast.text(this.$t('AUDIOPLAYER_LANG.playAddressErr'));
        });

    },
    //列表切换
    onChangeMediaData (data,index,id) {
      console.log('列表切换',data, index, id);
      this.onPlay(index);
    },
    //播放
    onPlay(index){
      //判斷購買狀態
      let that = this
      let obj = this.pageData.items[index];
      console.log('列表obj',obj);

      if (this.pageData.salePrice != 0 && obj.isBuy != 1 && obj.canTry != 1) {
        if(this.isOrangeNews){
            if(this.isLogin){
              this.$routerHelper.goBuyPage(this.$router,this.columnId,"medialist")
            }else{
              this.$router.push({
                  path: '/login'
                })
            }
          }else{
            //彈出購買提示
            if(this.isLogin){
              //已登錄
              this.$dialog.confirm({
                message: this.$t('AUDIOPLAYERDE_LANG.shwoDialog.1'),
                confirmButtonText: this.$t('AUDIOPLAYERDE_LANG.shwoDialog.2')
              }).then(() => {
                this.$routerHelper.goBuyPage(this.$router,this.columnId,"medialist")
              }).catch(() => { });
            }else{
              //未登錄
              this.$dialog.confirm({
                message: this.$t('AUDIOPLAYERDE_LANG.showDialogLoginEnd.1'),
                confirmButtonText: this.$t('AUDIOPLAYERDE_LANG.showDialogLoginEnd.2')
              }).then(() => {
                this.$router.push({
                  path: '/login'
                })
              }).catch(() => { });
            }
          }
        return;
      }

      if (this.pageData.items.length > 0) {
        this.pageData.items.forEach((item, idx) => {
          if (index == idx) {
            item.isPlaying = true;
          } else {
            item.isPlaying = false;
          }
        });
        this.$set(this.pageData.items, index, this.pageData.items[index]);
      }

      if (this.index != index) {

        this.index = index;
        this.getAudioData(this.pageData.items[index].id);
      } else {
        this.handlePauseOrPlay();
      }


      //设置是否有上下首
      this.hasPre = index != 0;
      this.hasNext = index + 1 < this.pageData.items.length;

      this.audionIndex = index
      this.mediaData = this.pageData.items[index]
      console.log('pageData', this.pageData.items[index]);

    },
    //上一首
    handlePre(index){
      if(this.audionIndex != 0){
        this.onPlay(this.audionIndex - 1)
      }else{
        this.$toast.text(this.$t('AUDIOPLAYER_LANG.firstContent'));
      }
    },
    //下一首
    handleNext(index){
      console.log('audioObjUrl.length', this.audioNum);

      if (this.audionIndex + 1 == this.pageData.items.length) {
        this.$toast.text(this.$t('AUDIOPLAYER_LANG.lastContent'));
        return;
      }else{
        //this.$toast.text(this.$t('CATALOG_LANG.dialogMessage'));
        //this.BuyDialog = true;
        console.log('this.isLogin111', this.isLogin);
        this.onPlay(this.audionIndex + 1)
      }

    },
    //后退
    handleBack() {
      if (this.audio.currentTime > 15) {
        this.audio.currentTime = this.audio.currentTime - 15
      }
    },
    //前进
    handleForward() {
      if (this.audio.duration - this.audio.currentTime > 15) {
        this.audio.currentTime = this.audio.currentTime + 15
      }
    },
    //暂停或播放
    handlePauseOrPlay() {
      //console.log(this.paused)
      let recordAudio = this.$refs.audio; //获取audio元素
      recordAudio.paused ? recordAudio.play() : recordAudio.pause()
      this.paused = !this.paused
    },
    //视频在可以播放时触发
    getDuration() {
      //console.log(this.$refs.audio.duration)
      //this.duration = this.timeFormat(this.$refs.audio.duration)
      this.duration = this.$utils.formatDurationSimple(this.mediaData.duration)
      this.durationValue = parseInt(this.$refs.audio.duration)
      this.audio = this.$refs.audio
    },
    //将单位为秒的的时间转换成mm:ss的形式
    timeFormat( number ) {
      let minute = parseInt(number / 60);
      let second = parseInt(number % 60);
      minute = minute >= 10 ? minute : "0" + minute;
      second = second >= 10 ? second : "0" + second;
      return minute + ":" + second;
    },
    //进度条发生变化时触发
    updateTime(e) {
      //console.log(e.target.currentTime,this.pageData.playNum)
      let currtime = e.target.currentTime
      let obj = this.pageData.items[this.audionIndex]
      //console.log("if", this.pageData.salePrice != 0,this.pageData.isBuy == 0, obj.probation != 0)
      if (this.pageData.salePrice != 0 && this.pageData.isBuy == 0 && obj.probation != 0) {
        if(currtime >= obj.probation){
          //暂停播放
          this.$refs.audio.pause();
          this.paused = true

          //彈出購買提示
          if(this.isLogin){
            //已登錄
            this.$dialog.confirm({
              message: this.$t('AUDIOPLAYER_LANG.dialogText.0'),
              confirmButtonText: this.$t('AUDIOPLAYER_LANG.dialogText.1')
            }).then(() => {
              this.$routerHelper.goBuyPage(this.$router,this.columnId,"medialist")
            }).catch(() => { });
          }else{
            //未登錄
            this.$dialog.confirm({
              message: this.isOrangeNews ? this.$t('AUDIOPLAYERDE_LANG.showOrangeDialogLoginEnd.1'): this.$t('AUDIOPLAYERDE_LANG.showDialogLoginEnd.1'),
              confirmButtonText: this.isOrangeNews ? this.$t('AUDIOPLAYERDE_LANG.showOrangeDialogLoginEnd.2'): this.$t('AUDIOPLAYERDE_LANG.showDialogLoginEnd.2')
            }).then(() => {
              this.$router.push({
                path: '/login'
              })
            }).catch(() => { });
          }

          return;
        }
      }

      this.audio = this.$refs.audio;
      if (!this.$refs.progress) return
      this.currentDuration = this.timeFormat(this.audio.currentTime)
      this.progress = this.currentDuration / this.audio.duration * 100
    },
    //进度条变化时
    onSliderChange(MoveX){
      this.handleMouseup();
    },
    //进度条改变时
    changeLong(){
      console.log(this.$refs.audio.currentTime)
      let ct = this.progress * this.duration / 100
      if (!isNaN(ct)) {
        this.$refs.audio.currentTime = ct
      }
      console.log(this.progress)
    },
    //鼠标弹起
    handleMouseup() {
      setTimeout(() => {
        this.$refs.audio.play()
        this.paused = false
        this.isMoveIn = false
      }, 200)
    },
    play(){
        this.paused = false;
        console.log("running~")
    },
    pause(){
        this.paused = true;
        console.log("stop!")
    },
    audioEnded(){
        console.log('end')
        this.onPlay(this.audionIndex + 1)
    }

  },
  mounted: function() {
    this.mediaId = this.$route.query.id;
    this.columnId = this.$route.query.columnId
    this.isOrangeNews = this.SERVER.APPID == "orangenews"
    //let _audio = this.$refs.audio;
    this.getData();
    //判斷是否登錄
    this.LOGIN2.getSession("no login")
      .then(session => {
        this.isLogin = true;
      })
      .catch(err => {
        this.isLogin = false;
      });
  }
};



// WEBPACK FOOTER //
// ./src/pages/audioDetail.vue